class AvailabilitySaveController {

    constructor($state, integrationService) {
        this.$state = $state;
        this.integrationService = integrationService;
    }

    $onInit () {
        this.activeTab = this.$state.params.tab || (this.availability.hasOwnProperty('inclusion_type') ? 'inclusion' : 'exclusion');
    }

    hasIntegration () {
        return this.integrationService.hasIntegration();
    }
}

AvailabilitySaveController.$inject = ['$state', 'integrationService'];

export default AvailabilitySaveController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/controllers/availability.save.controller.js